import { AnimationBuilder, AnimationMetadata, AnimationPlayer, animate, style } from '@angular/animations';
import { Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';

export class QuickDepositAnimationConfig {
    initialHeight: number;
    maxHeight: number;
    duration: number;
    startHeight: number;
    endHeight: number;
    inColumn: boolean;
}

export const defaultQuickDepositAnimationConfig = {
    initialHeight: 200,
    maxHeight: 720,
    duration: 400,
    startHeight: 0,
    endHeight: 0,
    inColumn: false,
};

@Directive({
    selector: '[bsQuickDepositAnimation]',
    standalone: false,
})
export class QuickDepositAnimationDirective {
    @Output() done = new EventEmitter<void>();

    private player: AnimationPlayer;
    private config: QuickDepositAnimationConfig;

    @Input('bsQuickDepositAnimation')
    set animationConfig(config: QuickDepositAnimationConfig) {
        if (this.player) {
            this.player.destroy();
        }

        this.config = config;
        const fadeInOutAnimation = this.getFadeInOutAnimation();
        const factory = this.builder.build(fadeInOutAnimation);

        const player = factory.create(this.el.nativeElement);
        player.onDone(this.onDone);

        player.play();
    }

    constructor(
        private builder: AnimationBuilder,
        private el: ElementRef,
    ) {}

    private getFadeInOutAnimation(): AnimationMetadata[] {
        let duration = Math.abs(this.config.startHeight - this.config.endHeight);

        if (!duration) {
            return [];
        }

        if (duration < 200) {
            duration = 200;
        }

        if (duration > 400) {
            duration = 400;
        }

        return [style({ height: `${this.config.startHeight}px` }), animate(`${duration}ms`, style({ height: `${this.config.endHeight}px` }))];
    }

    private onDone = (): void => {
        const iframe = this.el.nativeElement;
        const scroller = iframe.parentElement;

        if (scroller.clientHeight < scroller.scrollHeight) {
            iframe.maxHeight = scroller.clientHeight;
        }

        this.done.emit();
    };
}
